import React, { useEffect } from "react";
import HeaderMenu from "../component/Navbar/headermenu";
import TaskManagementOrganizeTrack from "../component/TaskManagement/TaskManagementOrganizeTrack";
import PowerfulTableSection from "../component/TaskManagement/PowerfulTableSection";
import TaskTable from "../component/TaskManagement/PowerfulTableSection";
import CustomStatuses from "../component/TaskManagement/CustomStatuses";
import ChecklistSection from "../component/TaskManagement/ChecklistSection";
import TaskHistoryTimelineSection from "../component/TaskManagement/TaskHistoryTimelineSection";
import SimpleTimeTrackingSection from "../component/TaskManagement/SimpleTimeTrackingSection";
import NotesSection from "../component/TaskManagement/NotesSection";
import ChangeRequestsSection from "../component/TaskManagement/ChangeRequestsSection";
import RecurringTasksEnhanced from "../component/TaskManagement/RecurringTasksEnhanced";
import Powerful_features_Titles from "../component/TaskManagement/Powerful_features_Titles";
import CustomFooter from "../component/Footer/customFooter";
import "../assets/css/careers.css";
export default function TaskManagement() {
  useEffect(() => {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);
  return (
    <div>
      <HeaderMenu />
      <section>
        <TaskManagementOrganizeTrack />
        <TaskTable />
        <CustomStatuses />
        <ChecklistSection />
        <TaskHistoryTimelineSection />
        <SimpleTimeTrackingSection />
        <NotesSection />
        {/* <ChangeRequestsSection /> */}
        <RecurringTasksEnhanced />
        <Powerful_features_Titles />
      </section>
      <CustomFooter />
    </div>
  );
}
